import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import NFTNav from "../components/NavComponents/NFTNav";
import PerksList from "../components/desktop/PerksList";
import { io } from 'socket.io-client';
import { mintNFT, sendMessagePerk, airdropNFT } from '../utils/backendUtils';
import SocialConnectModalComponent from '../components/NavComponents/SocialConnectModalComponent'
import { getLoginInformation,
    setPaymentDetails,
    setWalletDetails,
    setSocialHandleInformation
} from '../utils/loginHelper';
import eventBus from '../utils/globalPubSub';
import Lottie from 'react-lottie';
import animationData from '../assets/loader.json';
import { useHistory } from "react-router-dom";
import { fethchGlipBox } from '../utils/backendUtils';

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 36px;

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
   
    letter-spacing: -0.03em;

    color: #FFFFFF;

    color: #fff;
   
`;


const ActionBoxTitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    text-transform: uppercase;
`;

const ActionBoxSubtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 15px;
    margin-bottom: 24px;
`;


const ActionBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #FFFFFF;
    padding: 50px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;
`;


const Description = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.4;
    margin-bottom: 32px;
`;


const BotBar = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.04);
    padding: 15px;
    flex-direction: column;
    width: 100%;
`;

const BotBarTitle = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-bottom: 5px;
`;


const GreenButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(255, 255, 255, 1);
    background-blend-mode: overlay;
    border-radius: 12px;
    color: #000;
`;

const BotBarCount = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;
`;

const CardWrapper = styled.span`
    width: 100%;
    margin: 16px 0px;
    height: 345px;
    /* width: 245px; */
    @media (min-device-width: 481px) {
        width: 245px;
        margin: 10px;
        height: 245px
    }
`;

const PurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 10px 32px;
`;

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

export default function DemoWallet(props) {    
    const [loggedIn, setLoggedIn] = useState(false);
    const [tranferring, settranferring] = useState(false);
    const [transferAddress, setTransferAddress] = useState('');
    const [nfts, setNfts] = useState([]);

    const handleLogin = async (loginValue:any) => {
        setLoggedIn(loginValue);
    }

    const handleLogout = ()=> {
        window.glipAuthGlobal.logout()
    }

    
    const handleTransferuttonClick = async (transferToAddress, itemId) => {
        console.log(transferToAddress, itemId);
        await window.glipAuthGlobal.transferNFT(
            transferToAddress, itemId);
        settranferring(true);
    };

    const startLoginProcess = () =>{
        window.glipAuthGlobal.showConnectModal(['google']);
    }

    const handleFetchClick = async ()=>{
        let tnfts = await window.glipAuthGlobal.fetchNFTs();
        console.log(tnfts)
        if(!tnfts){
            return;
        }
        setNfts(tnfts);
        console.log(nfts);
    }

    useEffect(()=>{
        console.log('amazing')
        window.glipAuthGlobal.init(
            'testnet', 'matic', handleLogin)

    },[]);

    
    const nft_list = nfts.map((item, index) => {
        return (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
                <div  style={{margin: 8, color:'white'}}>
                    {item.mintTxId}
                </div>
                <input value={transferAddress} onChange={
                (val)=> setTransferAddress(val.target.value)} style={{padding:'12px 20px', margin: 8, background: 'transparent', borderRadius: 12, border: '1px solid rgba(255,255,255,0.4)'}} placeholder="Please enter address" />
                <GreenButton onClick={() => handleTransferuttonClick(
                    transferAddress, item.tokenDataId
                    
                )} style={{margin: 8}}>Transfer</GreenButton>
            </div>
        );
    });
    

    
    return (
        <>
        <Mobile>
        </Mobile>       
        <Desktop style={{}}>
            {loggedIn ? <>
                
                <br></br><br></br><br></br>
                <div style={{padding: 40, display : 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100vh', height: '100%', flexDirection: 'column'}}>                        
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <GreenButton onClick={() => handleLogout()}>Logout</GreenButton>
                        <GreenButton onClick={() => handleFetchClick()}>Fetch NFT</GreenButton>                                                
                    </div>
                    <br></br>
                    {nft_list}
                </div>
            </> :
            <>
                <div style={{padding: 40, display : 'flex', justifyContent: 'center', alignItems: 'center', width: '100vh', height: '100vh'}}>
                    <PurpleButton onClick={() => startLoginProcess()}>LOGIN</PurpleButton>
                </div>
            </>
            }
            
            
        </Desktop>
        </>
    );
}

